export default "__VITE_ASSET__qFir_0wz__"